import { FunctionComponent, useContext } from 'react';

import { ILayoutProvider, LayoutContext } from '../../context/LayoutContext';
import { EnableLocationModal } from '../../context/utils/LocationModals';
import { IInventoryProvider } from '../../interfaces/service/InventoryServiceManagerInterface';
import { MainContainer } from '../../layout/components/MainContainer';
import { InventoryContextSM } from '../../serviceContextManager/inventory/InventoryServiceManager';
import { CaptureLimitComunicationModal } from './components/CaptureLimitComunicationModal';
import { ModifyDisableSam } from './components/DisableSam';
import { InventaryTable } from './components/InventoryTable';
import { ModifyWhiteListSam } from './components/ModifyWhiteListSam';
import { RechargeCouterModal } from './components/rechargeCouterModal';
import { RechargesCounterHistoryModal } from './components/RechargesCounterHistoryModal';
import { RightMenu } from './components/rightMenu/RightMenu';

export const Inventory: FunctionComponent = () => {
  const serviceInventory = useContext<IInventoryProvider>(InventoryContextSM);
  const layoutService = useContext<ILayoutProvider>(LayoutContext);

  const renderContent = () => {
    return (
      <div className="flex w-full h-full relative flex-row">
        <div className="flex grow h-full relative flex-col content-center items-center overflow-x-auto justify-center p-4 ">
          <InventaryTable serviceInventory={serviceInventory} />
          <RechargeCouterModal serviceInventory={serviceInventory} />
          <ModifyWhiteListSam serviceInventory={serviceInventory} />
          <ModifyDisableSam serviceInventory={serviceInventory} />
          <RechargesCounterHistoryModal serviceInventory={serviceInventory} />
          <CaptureLimitComunicationModal serviceInventory={serviceInventory} />
          <EnableLocationModal layoutService={layoutService} />
        </div>
      </div>
    );
  };

  const renderRightComponent = () => {
    return (
      <RightMenu
        dataRow={serviceInventory.dataRow}
        selectMenu={serviceInventory.selectMenu}
        setOpenRightMenu={serviceInventory.setOpenRightMenu}
        updateTable={serviceInventory.updateInventoryTable}
        layoutService={layoutService}
      />
    );
  };

  return (
    <MainContainer
      openRightMenu={serviceInventory.openRightMenu}
      setOpenRightMenu={serviceInventory.setOpenRightMenu}
      loading={false}
      rightMenuContent={renderRightComponent}>
      {renderContent()}
    </MainContainer>
  );
};
